// third-party
import { combineReducers } from 'redux';

// project imports
import snackbarReducer from './slices/snackbar';
import menuReducer from './slices/menu';
import currenciesReducer from './currenciesReducer';
import countriesReducer from './countriesReducer';

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
    snackbar: snackbarReducer,
    menu: menuReducer,
    currencies: currenciesReducer,
    countries: countriesReducer
});

export default reducer;
